import React, { useEffect, useState, Fragment } from 'react';
export function CountdownTimer() {
  // Set target to 48 hours from now for demo purposes
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 10,
    seconds: 0
  });
  useEffect(() => {
    // In a real app, this would be a fixed future date
    const targetDate = new Date().getTime() + 10 * 60 * 1000;
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate - now;
      if (distance < 0) {
        clearInterval(interval);
        setTimeLeft({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        });
        return;
      }
      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
        minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
        seconds: Math.floor(distance % (1000 * 60) / 1000)
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const timeBlocks = [{
    label: 'MINUTOS',
    value: timeLeft.minutes
  }, {
    label: 'SEGUNDOS',
    value: timeLeft.seconds
  }];
  return <div className="flex items-center justify-center gap-2 md:gap-4 my-6" data-id="element-249">
      {timeBlocks.map((block, index) => <Fragment key={block.label} data-id="element-250">
          <div className="flex flex-col items-center" data-id="element-251">
            <div className="bg-white text-urgency font-serif font-bold text-2xl md:text-4xl w-14 h-14 md:w-20 md:h-20 flex items-center justify-center rounded-lg shadow-sm border border-blush" data-id="element-252">
              {block.value.toString().padStart(2, '0')}
            </div>
            <span className="text-[10px] md:text-xs font-bold text-warm-muted mt-2 tracking-wider" data-id="element-253">
              {block.label}
            </span>
          </div>
          {index < timeBlocks.length - 1 && <div className="text-urgency font-serif font-bold text-2xl md:text-4xl pb-6" data-id="element-254">
              :
            </div>}
        </Fragment>)}
    </div>;
}